import React from 'react';
import styled from 'styled-components';

import { Flex } from 'components';

interface BoxSquareProps {
  lineWidth?: number;
  lineHeight?: number;
  active?: boolean;
}

const BoxLines = styled('div')<BoxSquareProps>`
  position: relative;
  width: ${(props) => `${props.lineWidth}px`};
  height: ${(props) => `${props.lineHeight}px`};

  border-width: 2px 2px 0 0;
  border-style: solid;
  border-color: ${({ theme, active }) => (active ? theme.colors.gray_600 : theme.colors.gray_500)};

  &::before {
    content: '';
    display: block;
    width: 14px;
    height: 14px;
    background: ${({ theme, active }) => (active ? theme.colors.primary_200 : theme.colors.gray_500)};
    position: absolute;
    top: 16px;
    left: calc(100% + 2px);
  }
`;

const BoxSquare = ({ lineWidth, lineHeight, active }: BoxSquareProps) => {
  const boxLineWidth = lineWidth || 40;
  const boxLineHeight = lineHeight || 150;

  return (
    <Flex mr={3}>
      <BoxLines lineWidth={boxLineWidth} lineHeight={boxLineHeight} active={active} />
    </Flex>
  );
};

export default BoxSquare;
